<div class="dialog--informal dialog__container" role="status" aria-live="polite">
  <div class="dialog__header">
    {{ "webPos.PaymentStatus.CheckingIncompletePayments" | translate }}
  </div>
  <div class="dialog__content">
    <mat-spinner class="pending-payment-check__spinner" [diameter]="60"></mat-spinner>
    <span class="dialog__message">{{ "webPos.PaymentStatus.ContactingSobit" | translate }}</span>
  </div>
</div>
